import React from 'react';
import { Zap } from 'lucide-react';

export const Logo = ({ className = "", size = "default", light = false }) => {
  const sizes = {
    small: { text: "text-xl", icon: 18, container: "w-8 h-8" },
    default: { text: "text-2xl", icon: 22, container: "w-9 h-9" },
    large: { text: "text-4xl", icon: 32, container: "w-12 h-12" }
  };

  const { text, icon, container } = sizes[size];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className={`${container} rounded-xl bg-gradient-to-br from-[#8FEC78] to-[#5BC943] flex items-center justify-center shadow-md`}>
        <Zap size={icon} className="text-white" strokeWidth={2.5} fill="white" />
      </div>
      <span className={`${text} font-bold ${light ? 'text-white' : 'text-[rgb(0,55,32)]'} tracking-tight`}>
        ez<span className={light ? 'text-[#8FEC78]' : 'text-[rgb(13,121,22)]'}>VI</span>
      </span>
    </div>
  );
};

export default Logo;
